import { FormEvent } from 'react';
import { Loader2 } from 'lucide-react';
import { SignUpFormData, SignUpValidationErrors } from '../hooks/useSignUpValidation';
import { Input, PasswordInput } from '../../../components/shared';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';

interface SignUpFormProps {
  formData: SignUpFormData;
  onChange: (field: keyof SignUpFormData, value: string) => void;
  onSubmit: (e: FormEvent) => void;
  errors: SignUpValidationErrors;
  loading: boolean;
}

export function SignUpForm({ formData, onChange, onSubmit, errors, loading }: SignUpFormProps) {
  return (
    <form className="space-y-6" onSubmit={onSubmit} data-testid="signup-form">
      {errors.general && (
        <Alert variant="destructive">
          <AlertDescription>{errors.general}</AlertDescription>
        </Alert>
      )}

      <Input
        id="email"
        name="email"
        label="Endereço de e-mail"
        type="email"
        autoComplete="email"
        placeholder="you@example.com"
        value={formData.email}
        onChange={(e) => onChange('email', e.target.value)}
        error={errors.email}
        loading={loading}
        required
        variant="secondary"
      />

      <Input
        id="fullName"
        name="fullName"
        label="Nome Completo"
        type="text"
        autoComplete="name"
        placeholder="John Doe"
        value={formData.fullName}
        onChange={(e) => onChange('fullName', e.target.value)}
        error={errors.fullName}
        loading={loading}
        required
        variant="secondary"
      />

      <PasswordInput
        id="password"
        name="password"
        label="Senha"
        autoComplete="new-password"
        placeholder="••••••••"
        value={formData.password}
        onChange={(e) => onChange('password', e.target.value)}
        error={errors.password}
        showPasswordHint={true}
        loading={loading}
        required
        variant="secondary"
      />

      <PasswordInput
        id="password-confirmation"
        name="password-confirmation"
        label="Confirmar Senha"
        autoComplete="new-password"
        required
        loading={loading}
        value={formData.passwordConfirmation}
        onChange={(e) => onChange('passwordConfirmation', e.target.value)}
        error={errors.passwordConfirmation}
        placeholder="••••••••"
        variant="secondary"
      />

      <div>
        <Button type="submit" disabled={loading} className="w-full">
          {loading ? (
            <>
              <Loader2 className="animate-spin -ml-1 mr-3 h-5 w-5" />
              Criando conta...
            </>
          ) : (
            'Criar conta'
          )}
        </Button>
      </div>
    </form>
  );
}